<script setup>
import router from '@/router';

import { useStore } from 'vuex';
import { computed } from 'vue';

defineOptions({
  name: 'RecuperRoom',
});

const store = useStore();

const therapistName = computed(() => store.getters.therapistName);
const htmlResponse = (content) => {
  if (content == null) return '';
  return content
    .replace(/(\\n\\n\d+).*?(?=\\n|$)/g, '<li>')
    .replace(/\\n/g, '<br>');
};

const goOutside = async () => {
  store.commit('leaveAllRooms');
  router.push({ name: `Home` });
};

const therapyMessages = computed(() => {
  return store.getters.therapyMessages;
});
</script>
<template>
  <div class="therapy is-size-6-mobile is-size-5-tablet">
    <h1 class="maintitle title is-size-3-mobile is-size-2-tablet">
      RECUPEREER KAMER VAN DE KRENKKLINIEK
    </h1>

    <div v-if="therapyMessages && therapyMessages.length != 0">
      <div
        v-for="(message, index) in therapyMessages"
        :key="index"
        class="messagewrap"
        :class="[message.role]"
      >
        <p class="role">
          {{ message.role == 'user' ? 'jij' : therapistName }}
        </p>
        <p class="message" v-html="htmlResponse(message.content)"></p>
      </div>
    </div>
    <div class="discussionheader">
      <div class="field">
        <div class="control">
          <button
            class="button is-success is-large is-size-6-mobile is-size-5-tablet"
            @click="goOutside"
          >
            naar buiten
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped></style>
